import {createAsyncThunk, createSlice, SerializedError} from "@reduxjs/toolkit";
import Guid from "_shared/guids/guid";
import UserEntityMemberInvitationAPIService from "legal-entities/invitations/member-invitations/email-based/_api/user-entity-member-invitation-api-service";
import { UserEntityMemberInvitationJSON } from "legal-entities/invitations/member-invitations/email-based/_schema/user-entity-member-invitation-schema";
import Session from "users/__session/session";

type UserEntityMemberInvitationsState = {
  byId: {
    entries: Record<string, UserEntityMemberInvitationJSON>;
    loading: Record<string, boolean>;
    error: Record<string, SerializedError | null>;

  }
};

const initialState: UserEntityMemberInvitationsState = {
  byId: {
    entries: {},
    loading: {},
    error: {}
  }
};

const populateUserEntityMemberInvitationById = createAsyncThunk(
  "userEntityMemberInvitations/getUserEntityMemberInvitationById",
  async ({ session, id }: { session: Session, id: Guid }, thunkAPI) => {
    try {
      const apiService = new UserEntityMemberInvitationAPIService(session);
      return await apiService.getUserEntityMemberInvitationById(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
const userEntityMemberInvitationsSlice = createSlice({
  name: "userEntityMemberInvitations",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(populateUserEntityMemberInvitationById.pending, (state, action) => {
      const invitationId = action.meta.arg.id?.value;
      if (!invitationId) return;
      state.byId.loading[invitationId] = true;
      state.byId.error[invitationId] = null;
    });
    builder.addCase(populateUserEntityMemberInvitationById.fulfilled, (state, action) => {
      const invitationId = action.meta.arg.id?.value;
      if (!invitationId) return;
      state.byId.entries[invitationId] = action.payload.toJSON();
      state.byId.loading[invitationId] = false;
      state.byId.error[invitationId] = null;
    });
    builder.addCase(populateUserEntityMemberInvitationById.rejected, (state, action) => {
      const invitationId = action.meta.arg.id?.value;
      if (!invitationId) return;
      state.byId.loading[invitationId] = false;
      state.byId.error[invitationId] = action.error;
    });
  }
});

export default userEntityMemberInvitationsSlice;
